import { Component } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { APP_ROUTE } from 'app/app-routing.constant';
import { AuthenticationService, PermissionsService, UserRole } from 'app/core/authentication';
import { DefaultPageRouteService, RouterService } from 'app/core/navigation';
@UntilDestroy()
@Component({
    selector: 'kh-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.less'],
    standalone: false
})
export class PageNotFoundComponent {
  public isLoading = true;
  public isLoggedIn = false;

  public constructor(
    private authService: AuthenticationService,
    private permissionsService: PermissionsService,
    private readonly router: RouterService,
    private readonly defaultRoutingService: DefaultPageRouteService,
  ) {}

  ngOnInit() {
    this.authService.isAuthorized()
    .pipe(untilDestroyed(this))
    .subscribe(isAuthorized => {
      if (isAuthorized && this.permissionsService.hasOnlyRole(UserRole.student)) {
        // go to student not found if they are only a student
        this.router.navigate(APP_ROUTE.STUDENT.PAGE_NOT_FOUND.route());
        return;
      }
      this.isLoggedIn = isAuthorized;
      this.isLoading = false;
    });
  }

  public navigateToHome() {
    this.defaultRoutingService.routeToDefaultPage();
  }
}
